"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = exports.edit = exports.remove = exports.create = exports.getAll = void 0;
var axios_1 = __importDefault(require("axios"));
var get = function (id) {
    return axios_1.default.post("/vacancy-alerts/get/".concat(id));
};
exports.get = get;
var getAll = function () {
    return axios_1.default.post('/vacancy-alerts/all');
};
exports.getAll = getAll;
var create = function (_a) {
    var input = _a.input;
    return axios_1.default.post('/vacancy-alerts/create', input);
};
exports.create = create;
var remove = function (_a) {
    var id = _a.id;
    return axios_1.default.delete("/vacancy-alerts/delete/".concat(id));
};
exports.remove = remove;
var edit = function (_a) {
    var id = _a.id, input = _a.input;
    return axios_1.default.put("/vacancy-alerts/edit/".concat(id), input);
};
exports.edit = edit;
